import React from "react";
import { ListWithAvatarAndButton } from "@components/molecules";
export const MyRequestsOrganism = () => {
    return (
       <ListWithAvatarAndButton/>
    )
}